import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthInlineVideoConverter extends CmsConverterService<FullWidthInlineVideoData> {
  convertData (source: CmsComponent) {
    return {
      videoId: source?.otherProperties?.formData?.st_video ?? ''
    }
  }
}

export const FULL_WIDTH_INLINE_VIDEO_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, FullWidthInlineVideoData>>(
  'FullWidthInlineVideoConverter')

export interface FullWidthInlineVideoData extends ConvertedComponentData {
  videoId: string;
}
